import { OrbitControls } from "@react-three/drei";

/**
 * 相机控制配置 - 组件内聚
 */
const CONTROLS_CONFIG = {
  autoRotate: true,
  autoRotateSpeed: 0.5,
  enableZoom: true,
  enablePan: false,
  minDistance: 2,
  maxDistance: 8,
  minPolarAngle: 0,
  maxPolarAngle: Math.PI / 2,
  dampingFactor: 0.05,
};

/**
 * 工具函数 - 检测触摸设备
 */
const isTouchDevice = () => {
  if (typeof window === "undefined") return false;
  return "ontouchstart" in window;
};

/**
 * 相机控制组件 - 内聚相机控制逻辑
 * 负责管理OrbitControls的所有交互行为
 */
export function CameraControls() {
  return (
    <OrbitControls
      makeDefault
      autoRotate={CONTROLS_CONFIG.autoRotate}
      autoRotateSpeed={CONTROLS_CONFIG.autoRotateSpeed}
      enableZoom={CONTROLS_CONFIG.enableZoom}
      enablePan={CONTROLS_CONFIG.enablePan}
      minDistance={CONTROLS_CONFIG.minDistance}
      maxDistance={CONTROLS_CONFIG.maxDistance}
      minPolarAngle={CONTROLS_CONFIG.minPolarAngle}
      maxPolarAngle={CONTROLS_CONFIG.maxPolarAngle}
      dampingFactor={CONTROLS_CONFIG.dampingFactor}
      enableDamping={true}
      rotateSpeed={isTouchDevice() ? 0.8 : 1.0}
      zoomSpeed={isTouchDevice() ? 0.6 : 1.0}
      panSpeed={isTouchDevice() ? 0.5 : 1.0}
      touches={{
        ONE: 2, // ROTATE
        TWO: 1, // DOLLY
      }}
    />
  );
}